import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const deleteVenue = async (venueId: string): Promise<void> => {
  const res = await fetch(`${API_URL}/venues/${venueId}`, {
    method: 'DELETE',
  });

  if (res.status === Status.BAD_REQUEST || !res.ok) {
    throw new Error('Could not delete venue');
  }
};
